import '../LandingPage/LandingPage.scss';
import {  Grid } from '@mui/material';
import PlatformCostLogo from '../../assets/ri_money-dollar-circle-fill.svg';

import CustomDashboardIcon from '../../assets/Custom Dashboard_Small.svg';
import { useEffect, useState, lazy } from 'react';
import landingBackArrow from '../../assets/landingBackArrow.svg';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { useTheme } from "@mui/material/styles";
import { hideRMPlatformCost } from '../../service/config'

// Lazy load components
const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('../LandingPage/ModuleLandingFooter'));
const capabilitiesNew : any = localStorage.getItem('capabilities');

export default function FinanceOpsLanding() {
	const theme= useTheme();
	const colors = theme.palette;
	const [, setMemberData] = useState<any>(null);
	const [controller, _] = usePepwiseAuthController();
	const { accessToken } = controller;
	const capabilitiesArray = capabilitiesNew ? capabilitiesNew.split(',') : [];
	

	// to display data
	useEffect(() => {
		setMemberData(accessToken);
	}, []);

	//navigate to resource-mapping observability
	const handleResourceMappingClick = (event: any, type: string, url: string) => {
		event.preventDefault(); // Prevent the default context menu from showing up
		if (type === 'blank') {
			// Open the URL in a new tab if type is 'blank'
			window.open(url, '_blank');
		} else {
			// Navigate to the provided URL in the current tab
			window.location.href = url;
		}
	};

	const handleBackClick = () => {
		window.location.href = '/LandingPage';
	};

	return (
		<div className="outerLandingPageContainer" style={{ backgroundColor: `${colors.backgroundLight.primary}` }}>
			{/* <Header memberData={memberData} /> */}
			<div style={{ maxWidth: '86%', margin: '0 auto' }}>
				<div className="landingMessage-container">
					<img src={landingBackArrow} alt="CCLogo" className="landingMessageImage" onClick={handleBackClick} />
					<p className="landingMessage" style={{ color: `${colors.textLight.secondary}` }}>{`Finance(FinOps) Dashboard`}</p>
				</div>

				<div className="welcome_text">
					<p style={{ color: `${colors.textLight.secondary}` }}>Click on the module below to monitor!</p>
				</div>
				<Grid container spacing={1} style={{ marginTop: '0px' }}>
					{capabilitiesArray.includes('Resource Mapping') ? (
					<Grid
						item
						xs={4}
						onClick={(e) => handleResourceMappingClick(e, 'no-blank', '/finops/resourcemapping/programs')}
						onContextMenu={(e) => {
							e.preventDefault();
							handleResourceMappingClick(e, 'blank', '/finops/resourcemapping/programs');
						}}
					>
						<div className="observalbility_screens" style={{ textAlign: 'center' }}>
							<div className="title">
								<img
									src={CustomDashboardIcon}
									alt="tableauLogo"
									className="obs_logo"
									style={{ display: 'block', margin: '0 auto' }}
								/>
							</div>
							<div>
								<h3 className="obsTitle" style={{ margin: '10px 0' }}>
									Resource Mapping
								</h3>
							</div>
							<p
								className="message1"
								title="Monitor and update the resources."
								style={{ margin: '0', textAlign: 'center' }}
							>
								Monitor and update the resources.
							</p>
						</div>
					</Grid>
					) : (
						''
					)}
					{capabilitiesArray.includes('Platform Cost') && !hideRMPlatformCost ? (
					<Grid
						item
						xs={4}
						onClick={(e) => handleResourceMappingClick(e, 'no-blank', '/platformCostObs/dashboard')}
						onContextMenu={(e) => {
							e.preventDefault();
							handleResourceMappingClick(e, 'blank', '/platformCostObs/dashboard');
						}}
					>
						<div className="observalbility_screens" style={{ textAlign: 'center' }}>
							<div className="title">
								<img
									src={PlatformCostLogo}
									alt="platformLogo"
									className="obs_logo"
									style={{ display: 'block', margin: '0 auto' }}
								/>
							</div>
							<div>
								<h3 className="obsTitle" style={{ margin: '10px 0' }}>
									Platform Cost
								</h3>
							</div>
							<p
								className="message1"
								title="View cost analysis across different sectors."
								style={{ margin: '0', textAlign: 'center' }}
							>
								View cost analysis across different sectors.
							</p>
						</div>
					</Grid>
					) : (
						''
					)}
				</Grid>
			</div>
			<Footer />
		</div>
	);
}
